/**
 * Globally shared MMD runtime settings
 *
 * This class is used to share settings across the MMD runtime
 */
export class MmdRuntimeShared {
    /**
     * Default value of `IMmdModelCreationOptions.materialProxyConstructor`
     */
    static MaterialProxyConstructor = null;
}
